var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"ma-3",attrs:{"src":require('@/assets/wawee-logo-neg-web.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }